import { render, staticRenderFns } from "./chatOnline.vue?vue&type=template&id=58318f63&scoped=true&"
import script from "./chatOnline.vue?vue&type=script&lang=js&"
export * from "./chatOnline.vue?vue&type=script&lang=js&"
import style0 from "./chatOnline.vue?vue&type=style&index=0&id=58318f63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58318f63",
  null
  
)

export default component.exports